export type DeviceInputIssue = { id: string; title: string; fields: string[] };

export function deviceInputIssues(devices: any[]): DeviceInputIssue[] {
  return devices.flatMap((device, index) => {
    const fields = [['title', '装置名称'], ['device_type', '装置类型'], ['description', '希望如何改变剧情']]
      .filter(([key]) => !String(device[key] || '').trim()).map(([, label]) => label);
    return fields.length ? [{ id: device.id, title: String(device.title || `第 ${index + 1} 个装置`), fields }] : [];
  });
}

export function analysisWaitHint(seconds: number): string {
  return seconds < 30
    ? '近期六场项目实测约 10–30 秒；复杂改动可能更久。'
    : '已超过近期演示项目的常见耗时，尚未收到结果；这不代表分析已完成。';
}

export function deviceRequestError(error: any): string {
  if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') {
    return '本次等待已超时，未收到分析结果。装置草稿仍在当前页面，请点击“重新分析”；尚未修改已保存的剧情与剧本。';
  }
  return String(error?.response?.data?.error || error?.message || '请求失败，请重试。');
}
